export default function CompanyValues() {
  const values = [
    {
      icon: 'ri-user-star-line',
      title: '숙련된 기술진',
      description: '장기근속 직원들의 전문성과 노하우로 최상의 품질을 보장합니다',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: '신뢰와 품질',
      description: '30년 전통을 바탕으로 한 검증된 품질과 신뢰를 제공합니다',
      color: 'from-amber-500 to-amber-600'
    },
    {
      icon: 'ri-tools-line',
      title: '특수목형 전문',
      description: '포장재 및 제품 생산용 특수목형 제작 및 개발에 특화되어 있습니다',
      color: 'from-slate-700 to-slate-800'
    },
    {
      icon: 'ri-global-line',
      title: '전국 네트워크',
      description: '전국에 거래처를 두고 빠르고 정확한 서비스를 제공합니다',
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: '최신 기술',
      description: '레이저 가공 기술을 접목하여 더욱 정밀하고 다양한 제품을 생산합니다',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '고객 맞춤 서비스',
      description: '소량부터 대량까지 고객의 요구에 맞춘 맞춤형 솔루션을 제공합니다',
      color: 'from-rose-500 to-rose-600'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">재기목형의 핵심 가치</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto mb-6"></div>
          <p className="text-lg text-slate-600">업계 최고를 만드는 우리의 강점</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl border border-slate-200 hover:border-amber-300 hover:shadow-xl transition-all duration-300"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${value.color} rounded-xl mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{value.title}</h3>
              <p className="text-slate-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-6">
            재기목형과 함께 성장하세요
          </h3>
          <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
            30년 전통의 기술력과 최신 레이저 가공 기술을 바탕으로<br />
            고객 여러분의 성공적인 비즈니스를 지원하겠습니다
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:02-2263-8248"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-amber-500 to-amber-600 text-white font-bold rounded-xl hover:from-amber-600 hover:to-amber-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-xl"></i>
              02-2263-8248
            </a>
            <a
              href="/estimate"
              className="inline-flex items-center justify-center px-8 py-4 bg-white text-slate-900 font-bold rounded-xl hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line mr-2 text-xl"></i>
              견적 문의하기
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
